// extracted by mini-css-extract-plugin
export default {"rounds":"SeasonRoundsList_rounds__UP1mI"};